// Thanks: https://stackoverflow.com/questions/56650634/merge-objects-in-javascript-while-ignoring-property-values-that-are-undefined-j
export const definedProps = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined)) as Partial<T>;

